import { Module } from "wrapper6";
import Glide from "@glidejs/glide";

var $ = jQuery;

export default class Sliders extends Module {

	ready(app) {

        this.addDefaultSlider('.single-product-glide');
        this.addSimpleSlider('.cart-product-glide', 2);
        this.addSimpleSlider('.thankyou .glide');
    }

    addDefaultSlider(el) {
        if (document.querySelector(el)) {
            var varName = new Glide(el, {
                type: 'slider',
                startAt: 0,
                perView: 3,
                rewind: false,
                bound: true,
                breakpoints: {
                    1100: {
                      perView: 2
                    },
                    600: {
                      perView: 1
                    }
                }
            })

            varName.mount();
            
            if (document.querySelector(el).querySelectorAll('.glide__slide').length === 1) {
                varName.disable()
            }


            // disable/enable slider arrows if first or last
            varName.on('move', function() {
                document.querySelector(el).querySelector('.single-product-glide .glide__arrow--left').classList.remove('disabled');
                document.querySelector(el).querySelector('.single-product-glide .glide__arrow--right').classList.remove('disabled');
            });

            varName.on('run.start', function() {
                document.querySelector(el).querySelector('.single-product-glide .glide__arrow--left').classList.add('disabled');
            });

            varName.on('run.end', function() {
                document.querySelector(el).querySelector('.single-product-glide .glide__arrow--right').classList.add('disabled');
            });    


            // add transparent class to correct slides
            varName.on('run.after', function() {
                const ACTIVE_SLIDE = document.querySelector('.single-product-glide .glide__slide--active');
                const TRANSPARENT_GLIDES = document.querySelectorAll('.single-product-glide .glide__slide.transparent');

                for (let i = 0; i < TRANSPARENT_GLIDES.length; i++) {
                    const element = TRANSPARENT_GLIDES[i];
                    element.classList.remove('transparent');                    
                }

                if (ACTIVE_SLIDE.previousElementSibling) {
                    ACTIVE_SLIDE.previousElementSibling.classList.add('transparent');
                    
                }

                if (ACTIVE_SLIDE.nextElementSibling.nextElementSibling.nextElementSibling) {
                    ACTIVE_SLIDE.nextElementSibling.nextElementSibling.nextElementSibling.classList.add('transparent');
                }
                
            });
        }
    }

    addSimpleSlider(el, $perView = 1) {
        if (document.querySelector(el)) {
            var varName = new Glide(el, {
                type: 'carousel',
                startAt: 0,
                perView: $perView,
                gap: 18,
                breakpoints: {
                    650: {
                      perView: 1
                    }
                }
            })
    
            varName.mount();            
        }

    }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_sliders.js